import styled from "styled-components";

export const PageHeaderStyled = styled.div<{ isDisabled?: boolean }>`
  opacity: ${({ isDisabled }): string => (isDisabled ? "0.5" : "1")};
  cursor: ${({ isDisabled }): string => (isDisabled ? "not-allowed" : "")};
  pointer-events: ${({ isDisabled }): string => (isDisabled ? "none" : "auto")};
`;
